// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"Y0-z","subtitle":"Z0-z","wrapper":"_0-z","leftArrow":"a1-z","rightArrow":"b1-z"};